import { ArrowRightIcon } from 'lucide-react'

import { QleDetails } from 'components/QleDetails'
import OpacityTransition from 'components/reusable/OpacityTransition'
import { Button } from 'slab'
import { usePatchMemberOnboardingEnrollmentEventsEnrollmentEventId } from 'utils/web_api'
import { type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentSubtype } from 'utils/web_api.schemas'

import { QLEButtonLayout } from '../components/QLEButtonLayout'
import { useOnboarding } from '../OnboardingContext'
import { type StepComponentProps } from '../types'

type QleType = PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentSubtype

// This page is in the actual progress_controller, not the qle_start_controller, but looks the same as QleStartPage.tsx
// Main difference is that it calls PATCH /enrollment_events/:enrollment_event_id on Next instead of POST
export const QleDetailsPage = ({
  navigateToNextStep,
  navigateToPreviousStep,
  navigateToSpecificStep,
}: StepComponentProps) => {
  const { enrollmentEventId, onboardingData } = useOnboarding()
  const updateEnrollmentEvent = usePatchMemberOnboardingEnrollmentEventsEnrollmentEventId()

  const handleNext = async ({ qleType, qleDate }: { qleType: QleType, qleDate: Date }) => {
    const formattedDate = qleDate.toISOString().split('T')[0]

    await updateEnrollmentEvent.mutateAsync({
      enrollmentEventId,
      data: {
        enrollment_subtype: qleType,
        provided_qle_event_date: formattedDate,
      },
    })
    navigateToNextStep?.()
  }

  return (
    <OpacityTransition>
      <QleDetails
        onSubmit={handleNext}
        initialQleType={onboardingData?.enrollment_event?.subtype as QleType | undefined}
        initialQleDate={onboardingData?.enrollment_event?.provided_qle_event_date}
        renderButtonLayout={({ submit, disabled }) => (
          <QLEButtonLayout
            backButton={
              <Button
                variant='secondary'
                onClick={() => navigateToPreviousStep?.(onboardingData)}
              >
                Back
              </Button>
            }
            rightButtons={
              <Button
                rightIcon={ArrowRightIcon}
                variant='primary'
                type='button'
                disabled={disabled}
                onClick={submit}
              >
                Next
              </Button>
            }
            navigateToSpecificStep={navigateToSpecificStep}
          />
        )}
      />
    </OpacityTransition>
  )
}

export default QleDetailsPage
